import React, { PropTypes } from 'react';
import PureComponent from 'components/PureComponent';

import arrow from './arrow.svg';
import mouse from './mouse.svg';

class ScrollDown extends PureComponent {

	static propTypes = {
		full: PropTypes.bool.isRequired,
		revert: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		full: true
	};

	render() {
		require('./ScrollDown.styl');
		return (
			<a className={`ScrollDown ${this.props.revert ? 'ScrollDown--revert' : ''}`} {...this.props}>
				{this.props.full &&
					<img src={mouse} width="20" height="33" className="ScrollDown__mouse" />
				}
				<img src={arrow} width="20" height="12" className="ScrollDown__arrow" />
			</a>
		);
	}

}

export default ScrollDown;



// WEBPACK FOOTER //
// ./src/components/ScrollDown/ScrollDown.js